module.exports = __webpack_public_path__ + "img/2@2x.93261c0d.webp";